import { Directive, ElementRef, HostBinding, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { JQueryStyleEventEmitter } from 'rxjs/internal/observable/fromEvent';
import { debounceTime } from 'rxjs/operators';
import { StateSidebarService } from '../services/state-sidebar.service';
import { ESidebarState } from '../enumerables/sidebarState';

@Directive({
  selector: '[sidebar-swipe]'
})
export class SlideActionDirective implements OnInit, OnDestroy {

  @HostBinding('style.width.px')
  public styleValue: number;

  private MIN_WIDTH = 50;
  private MAX_WIDTH = 250;
  private initialWidth: number;
  private Hammer: any;
  private panStartSubscription: Subscription;
  private panEndSubscription: Subscription;
  private panLeftRightSubscription: Subscription;
  private swipeLeftSubscription: Subscription;

  constructor(
    private element: ElementRef,
    private render: Renderer2,
    private sidebarService: StateSidebarService
  ) { }

  public ngOnInit(): void {
    const hammerPan = new Hammer(this.element.nativeElement,
      {
        recognizers: [
          [Hammer.Pan]
        ]
      }
    );

    const hammerSwipe = new Hammer(this.element.nativeElement,
      {
        recognizers: [
          [Hammer.Swipe]
        ]
      }
    );

    this.panStartSubscription = fromEvent(hammerPan as JQueryStyleEventEmitter, 'panstart').subscribe((x: any) => {
      this.render.removeClass(this.element.nativeElement, 'animate');
      this.initialWidth = (this.element.nativeElement as HTMLElement).offsetWidth;
    });

    this.panEndSubscription = fromEvent(hammerPan as JQueryStyleEventEmitter, 'panleft panright').subscribe((x: any) => {
      const width = this.initialWidth + x.deltaX;
      if (width > this.MIN_WIDTH && width <= this.MAX_WIDTH) {
        this.styleValue = this.initialWidth + x.deltaX;
      }
    });

    this.panLeftRightSubscription = fromEvent(hammerPan as JQueryStyleEventEmitter, 'panend').subscribe((x: any) => {
      this.render.addClass(this.element.nativeElement, 'animate');
      this.render.removeStyle(this.element.nativeElement, 'width');
      if (this.styleValue < (this.MAX_WIDTH * 0.35)) {
        this.sidebarService.setState(ESidebarState.closed);
      } else {
        this.sidebarService.setState(ESidebarState.open);
      }
    });

    this.swipeLeftSubscription = fromEvent(hammerSwipe as JQueryStyleEventEmitter, 'swipeleft').subscribe((x: any) => {
      this.sidebarService.setState(ESidebarState.closed);
    });
  }

  public ngOnDestroy(): void {
    this.panStartSubscription.unsubscribe();
    this.panEndSubscription.unsubscribe();
    this.panLeftRightSubscription.unsubscribe();
    this.swipeLeftSubscription.unsubscribe();
  }
}
